var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page"},[_c('div',{staticClass:"login-card"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("企业微信登录")]),_c('p',[_vm._v("请使用手机企业微信扫描下方二维码")]),_c('div',{attrs:{"id":"wxqr-container"}}),_c('div',{staticClass:"rakumart"},[_vm._v("西班牙RAKUMART-订单系统")])])])])
}]

export { render, staticRenderFns }